import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#3F51B5',
      '100': 'rgba(63, 81, 181, 0.08)',
      '200': 'rgba(63, 81, 181, 0.2)',
      light: 'rgba(63, 81, 181, 0.2)',
    },
    secondary: {
      main: '#B5B036',
    },
    error: {
      main: red.A400,
    },
  },
});

const theme = responsiveFontSizes(defaultTheme);

export { theme };
